export interface BellNotificationsRouter {
  goToNotificationsPage(): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BellNotificationsRouter = Symbol('BellNotificationsRouter');
